import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Delete } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));

export default function DiscountCodeTable(props) {
    const { data, setConfirmDialog ,handleDeleteRow,onRowClick} = props;

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    const stylH = {
        BorderBottom: "solid 0.5px",
        borderColor: "black",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        fontSize: "1rem",
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }
    return (
        <TableContainer component={Paper}>
            <Table
                size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: colors.red[300],
                            color: "#000",
                            fontWeight: "bold",
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} align="center">
                            {"رقم كود الخصم"}
                        </TableCell>

                        <TableCell style={stylH} align="center">
                            {"كود الخصم"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"نوع الخصم"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"الخصم"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"تاريخ البداية "}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"تاريخ النهاية"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {""}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, i) => (
                        <TableRow key={row.title}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.id}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row?.code}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row?.type===1?"مبلغ ":"نسبة"}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row?.type===1?row.monay:row.rate}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }} >{row.start_date}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowClick(row); }}>{row.end_date}</TableCell>
                            <TableCell align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    onClick={(e) => {
                                        setConfirmDialog({
                                            isOpen: true,
                                            onConfirm: () => {
                                                handleDeleteRow(e, row);
                                            },
                                        })
                                    }}
                                >
                                    <Delete size={"small"} />
                                </IconButton>

                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
